import React from 'react';

/**
 * Reusable empty-state placeholder.
 *
 * Props:
 *   icon        – emoji or ReactNode shown large above the heading
 *   title       – heading text
 *   description – body text below the heading
 *   children    – optional CTA button or extra content
 */
export default function EmptyState({ icon, title, description, children }) {
  return (
    <div className="empty-state">
      {icon && <div className="empty-state-icon">{icon}</div>}
      {title && <h2>{title}</h2>}
      {description && <p>{description}</p>}
      {children}
    </div>
  );
}
